
import { StandardDialog } from '@roc/ui';
import { ReferralFeeLink } from '@roc/feature-referral';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export const ReferrerInformationDialog = (props) => {
  const { open, onClose, loanId, brokerId, document } = props;
  const { referralFeeStore } = useStore();

  const getContent = () => {
    return (
      <ReferralFeeLink loanId={loanId} referralFeeStore={referralFeeStore} brokerId={brokerId} onClose={onClose} />
    );
  }

  return (
    <>
      {document?.taskId ? (
        <CustomTaskDialog
          open={open}
          title="Off Hud Broker ACH"
          handleClose={onClose}
          dialogContent={getContent()}
          taskId={document?.taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Off Hud Broker ACH"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={getContent()}
        />
      )}
    </>
  );
};

export default ReferrerInformationDialog;
